const dev = {
    API_ENDPOINT_URL: 'https://mobileweb.associatedasset.com/',
    HUB_API_ENDPOINT_URL: 'https://aamallaccesshubapi.azurewebsites.net/',
    REACT_APP : "http://localhost:3000/"
  };
  const prod = {
    API_ENDPOINT_URL: 'https://mobileweb.associatedasset.com/',
    HUB_API_ENDPOINT_URL: 'https://aamallaccesshubapi.azurewebsites.net/',
    REACT_APP : "https://brave-flower-0605bd81e.5.azurestaticapps.net/"
  };  
  const test = {
    API_ENDPOINT_URL: 'https://mobileweb.associatedasset.com/',
    HUB_API_ENDPOINT_URL: 'https://aamallaccesshubapi.azurewebsites.net/',
    REACT_APP : "https://brave-flower-0605bd81e.5.azurestaticapps.net/"

  };
  
  const getEnv = () => {
      switch (process.env.NODE_ENV) {
          case 'development':
              return dev
          case 'production':
              return prod
          case 'test':
              return test
          default:
              break;
      }
  }
  
  export const env = getEnv()
  